import type { ComponentProps } from 'react'
import dynamic from 'next/dynamic'
import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import type { CMIncludedWithMasterClassBannerProps } from './IncludedBanner'

// https://app.growthbook.io/features/pen-5502_v1
const CM_INCLUDED_W_MC_V2_FLAG = 'pen-5502_v1'

const numClasses = getNumberOfInstructors()

const CMIncludedWithMasterClassBanner = dynamic(() =>
  import('./IncludedBanner').then((m) => m.CMIncludedWithMasterClassBanner),
)

type IncludedWithMasterClassV2ExpProps = Pick<
  CMIncludedWithMasterClassBannerProps,
  'wrapper'
> &
  Pick<ComponentProps<typeof Experiment>, 'lazyload'>

export const IncludedWithMasterClassV2Exp = ({
  lazyload,
  wrapper,
}: IncludedWithMasterClassV2ExpProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Experiment
      name={CM_INCLUDED_W_MC_V2_FLAG}
      lazyload={lazyload}
      variant_1={() => (
        <CMIncludedWithMasterClassBanner
          text={t('course.pen-5502_v1.included')}
          wrapper={wrapper}
        />
      )}
      variant_2={() => (
        <CMIncludedWithMasterClassBanner
          text={t('course.pen-5502_v1.one_membership', { numClasses })}
          wrapper={wrapper}
        />
      )}
    />
  )
}
